import { gql } from "@apollo/client";

export const UPDATE_TICKET_ACCIDENT = gql`
  mutation addOrUpdateTicketInIncident(
    $input: AddOrUpdateTicketInIncidentInput!
  ) {
    addOrUpdateTicketInIncident(input: $input) {
      errors
      incidentUuid
      ticketUuid
      ticket {
        id
        accident
      }
    }
  }
`;

export const UPDATE_TICKET_ACTUAL_SPEED = gql`
  mutation addOrUpdateTicketInIncident(
    $input: AddOrUpdateTicketInIncidentInput!
  ) {
    addOrUpdateTicketInIncident(input: $input) {
      errors
      incidentUuid
      ticketUuid
      ticket {
        id
        actualSpeed
      }
    }
  }
`;

export const UPDATE_TICKET_CDL = gql`
  mutation addOrUpdateTicketInIncident(
    $input: AddOrUpdateTicketInIncidentInput!
  ) {
    addOrUpdateTicketInIncident(input: $input) {
      errors
      incidentUuid
      ticketUuid
      ticket {
        id
        cdl
      }
    }
  }
`;

export const UPDATE_TICKET_CODE = gql`
  mutation addOrUpdateTicketInIncident(
    $input: AddOrUpdateTicketInIncidentInput!
  ) {
    addOrUpdateTicketInIncident(input: $input) {
      errors
      incidentUuid
      ticketUuid
      ticket {
        id
        code
      }
    }
  }
`;

export const UPDATE_TICKET_COMMERCIAL_VEHICLE = gql`
  mutation addOrUpdateTicketInIncident(
    $input: AddOrUpdateTicketInIncidentInput!
  ) {
    addOrUpdateTicketInIncident(input: $input) {
      errors
      incidentUuid
      ticketUuid
      ticket {
        id
        commercialVehicle
      }
    }
  }
`;

export const UPDATE_TICKET_CURRENT_STATUS = gql`
  mutation addOrUpdateTicketInIncident(
    $input: AddOrUpdateTicketInIncidentInput!
  ) {
    addOrUpdateTicketInIncident(input: $input) {
      errors
      incidentUuid
      ticketUuid
      ticket {
        id
        currentStatus
      }
    }
  }
`;

export const UPDATE_TICKET_CV_HAZARD_FEE = gql`
  mutation addOrUpdateTicketInIncident(
    $input: AddOrUpdateTicketInIncidentInput!
  ) {
    addOrUpdateTicketInIncident(input: $input) {
      errors
      incidentUuid
      ticketUuid
      ticket {
        id
        cvHazardFee
      }
    }
  }
`;

export const UPDATE_TICKET_DEFENDANT_ACTIONS = gql`
  mutation addOrUpdateTicketInIncident(
    $input: AddOrUpdateTicketInIncidentInput!
  ) {
    addOrUpdateTicketInIncident(input: $input) {
      errors
      incidentUuid
      ticketUuid
      ticket {
        id
        defendantActions
      }
    }
  }
`;

export const UPDATE_TICKET_DEFENDANT_PARENT = gql`
  mutation addOrUpdateTicketInIncident(
    $input: AddOrUpdateTicketInIncidentInput!
  ) {
    addOrUpdateTicketInIncident(input: $input) {
      errors
      incidentUuid
      ticketUuid
      ticket {
        id
        defendantParent {
          id
          personalAttribute {
            id
            lastName
            firstName
            middleName
            mailingAddress {
              city
              id
              lat
              lng
              name
              state
              streetName
              streetNumber
              unit
              zip
            }
          }
        }
      }
    }
  }
`;

export const UPDATE_TICKET_DELIVERED_TO = gql`
  mutation addOrUpdateTicketInIncident(
    $input: AddOrUpdateTicketInIncidentInput!
  ) {
    addOrUpdateTicketInIncident(input: $input) {
      errors
      incidentUuid
      ticketUuid
      ticket {
        id
        deliveredToType {
          id
          name
          oriId
          position
        }
      }
    }
  }
`;

export const UPDATE_TICKET_DISPOSITION_PENALTY_AMOUNT = gql`
  mutation addOrUpdateTicketInIncident(
    $input: AddOrUpdateTicketInIncidentInput!
  ) {
    addOrUpdateTicketInIncident(input: $input) {
      errors
      incidentUuid
      ticketUuid
      ticket {
        id
        dispositionPenaltyAmount
      }
    }
  }
`;

export const UPDATE_TICKET_FATALITY = gql`
  mutation addOrUpdateTicketInIncident(
    $input: AddOrUpdateTicketInIncidentInput!
  ) {
    addOrUpdateTicketInIncident(input: $input) {
      errors
      incidentUuid
      ticketUuid
      ticket {
        id
        fatality
      }
    }
  }
`;

export const UPDATE_TICKET_FEDERAL_VIOLATION_CODE = gql`
  mutation addOrUpdateTicketInIncident(
    $input: AddOrUpdateTicketInIncidentInput!
  ) {
    addOrUpdateTicketInIncident(input: $input) {
      errors
      incidentUuid
      ticketUuid
      ticket {
        id
        federalViolationCode {
          id
          name
          oriId
          position
        }
      }
    }
  }
`;

export const UPDATE_TICKET_HAZMAT = gql`
  mutation addOrUpdateTicketInIncident(
    $input: AddOrUpdateTicketInIncidentInput!
  ) {
    addOrUpdateTicketInIncident(input: $input) {
      errors
      incidentUuid
      ticketUuid
      ticket {
        id
        hazmat
      }
    }
  }
`;

export const UPDATE_TICKET_HIGHWAY = gql`
  mutation addOrUpdateTicketInIncident(
    $input: AddOrUpdateTicketInIncidentInput!
  ) {
    addOrUpdateTicketInIncident(input: $input) {
      errors
      incidentUuid
      ticketUuid
      ticket {
        id
        highway {
          id
          name
          oriId
          position
        }
      }
    }
  }
`;

export const UPDATE_TICKET_ISSUED_AT = gql`
  mutation addOrUpdateTicketInIncident(
    $input: AddOrUpdateTicketInIncidentInput!
  ) {
    addOrUpdateTicketInIncident(input: $input) {
      errors
      incidentUuid
      ticketUuid
      ticket {
        id
        issuedAt
      }
    }
  }
`;

export const UPDATE_TICKET_ISSUED_TO = gql`
  mutation addOrUpdateTicketInIncident(
    $input: AddOrUpdateTicketInIncidentInput!
  ) {
    addOrUpdateTicketInIncident(input: $input) {
      errors
      incidentUuid
      ticketUuid
      ticket {
        id
        issuedTo {
          id
          personalAttribute {
            id
            lastName
            firstName
            middleName
          }
        }
      }
    }
  }
`;

export const UPDATE_TICKET_ISSUED_TO_ADDRESS = gql`
  mutation addOrUpdateTicketInIncident(
    $input: AddOrUpdateTicketInIncidentInput!
  ) {
    addOrUpdateTicketInIncident(input: $input) {
      errors
      incidentUuid
      ticketUuid
      ticket {
        id
        issuedToAddress {
          city
          id
          lat
          lng
          name
          state
          streetName
          streetNumber
          unit
          uuid
          validAddressAlerts {
            alertType {
              id
              name
              alertLevel
              oriId
              position
            }
            expireAt
            id
            notes
            createdAt
            officer {
              deptAttribute {
                id
                badge
                ori {
                  id
                  abbreviation
                }
              }
              personalAttribute {
                id
                firstName
                lastName
              }
            }
          }
          zip
        }
      }
    }
  }
`;

export const UPDATE_TICKET_IS_WARNING = gql`
  mutation addOrUpdateTicketInIncident(
    $input: AddOrUpdateTicketInIncidentInput!
  ) {
    addOrUpdateTicketInIncident(input: $input) {
      errors
      incidentUuid
      ticketUuid
      ticket {
        id
        isWarning
      }
    }
  }
`;
export const UPDATE_TICKET_LOCKED = gql`
  mutation addOrUpdateTicketInIncident(
    $input: AddOrUpdateTicketInIncidentInput!
  ) {
    addOrUpdateTicketInIncident(input: $input) {
      errors
      incidentUuid
      ticketUuid
      ticket {
        id
        locked
      }
    }
  }
`;

export const UPDATE_TICKET_MAILING_ADDRESS_VERIFIED = gql`
  mutation addOrUpdateTicketInIncident(
    $input: AddOrUpdateTicketInIncidentInput!
  ) {
    addOrUpdateTicketInIncident(input: $input) {
      errors
      incidentUuid
      ticketUuid
      ticket {
        id
        mailingAddressVerified
      }
    }
  }
`;

export const UPDATE_TICKET_MUNICIPAL_ORDINANCE = gql`
  mutation addOrUpdateTicketInIncident(
    $input: AddOrUpdateTicketInIncidentInput!
  ) {
    addOrUpdateTicketInIncident(input: $input) {
      errors
      incidentUuid
      ticketUuid
      ticket {
        id
        municipalOrdinance
      }
    }
  }
`;

export const UPDATE_TICKET_MUNICIPALITY = gql`
  mutation addOrUpdateTicketInIncident(
    $input: AddOrUpdateTicketInIncidentInput!
  ) {
    addOrUpdateTicketInIncident(input: $input) {
      errors
      incidentUuid
      ticketUuid
      ticket {
        id
        municipality {
          id
          name
          oriId
          position
        }
      }
    }
  }
`;

export const UPDATE_TICKET_NARRATIVE = gql`
  mutation addOrUpdateTicketInIncident(
    $input: AddOrUpdateTicketInIncidentInput!
  ) {
    addOrUpdateTicketInIncident(input: $input) {
      errors
      incidentUuid
      ticketUuid
      ticket {
        id
        narrative
      }
    }
  }
`;

export const UPDATE_TICKET_OFFICER = gql`
  mutation addOrUpdateTicketInIncident(
    $input: AddOrUpdateTicketInIncidentInput!
  ) {
    addOrUpdateTicketInIncident(input: $input) {
      errors
      incidentUuid
      ticketUuid
      ticket {
        id
        officer {
          id
          personalAttribute {
            lastName
            firstName
            middleName
            id
          }
          deptAttribute {
            ori {
              id
              oriName
              abbreviation
            }
            badge
            id
          }
        }
      }
    }
  }
`;

export const UPDATE_TICKET_OPERATOR = gql`
  mutation addOrUpdateTicketInIncident(
    $input: AddOrUpdateTicketInIncidentInput!
  ) {
    addOrUpdateTicketInIncident(input: $input) {
      errors
      incidentUuid
      ticketUuid
      ticket {
        id
        operator {
          id
          personalAttribute {
            id
            lastName
            firstName
            middleName
          }
        }
      }
    }
  }
`;

export const UPDATE_TICKET_PASSENGER_TICKET_EVIDENCE = gql`
  mutation addOrUpdateTicketInIncident(
    $input: AddOrUpdateTicketInIncidentInput!
  ) {
    addOrUpdateTicketInIncident(input: $input) {
      errors
      incidentUuid
      ticketUuid
      ticket {
        id
        passengerTicketEvidenceType {
          id
          name
          oriId
          position
        }
      }
    }
  }
`;

export const UPDATE_TICKET_PASSENGER_TICKET_OUTCOME = gql`
  mutation addOrUpdateTicketInIncident(
    $input: AddOrUpdateTicketInIncidentInput!
  ) {
    addOrUpdateTicketInIncident(input: $input) {
      errors
      incidentUuid
      ticketUuid
      ticket {
        id
        passengerTicketOutcomeType {
          id
          name
          oriId
          position
        }
      }
    }
  }
`;

export const UPDATE_TICKET_PASSENGER_TICKET_SEARCH = gql`
  mutation addOrUpdateTicketInIncident(
    $input: AddOrUpdateTicketInIncidentInput!
  ) {
    addOrUpdateTicketInIncident(input: $input) {
      errors
      incidentUuid
      ticketUuid
      ticket {
        id
        passengerTicketSearchType {
          id
          name
          oriId
          position
        }
      }
    }
  }
`;

export const UPDATE_TICKET_PENALTY = gql`
  mutation addOrUpdateTicketInIncident(
    $input: AddOrUpdateTicketInIncidentInput!
  ) {
    addOrUpdateTicketInIncident(input: $input) {
      errors
      incidentUuid
      ticketUuid
      ticket {
        id
        penalty
      }
    }
  }
`;
export const UPDATE_TICKET_PENALTY_MAX = gql`
  mutation addOrUpdateTicketInIncident(
    $input: AddOrUpdateTicketInIncidentInput!
  ) {
    addOrUpdateTicketInIncident(input: $input) {
      errors
      incidentUuid
      ticketUuid
      ticket {
        id
        penaltyMax
      }
    }
  }
`;
export const UPDATE_TICKET_PENALTY_MIN = gql`
  mutation addOrUpdateTicketInIncident(
    $input: AddOrUpdateTicketInIncidentInput!
  ) {
    addOrUpdateTicketInIncident(input: $input) {
      errors
      incidentUuid
      ticketUuid
      ticket {
        id
        penaltyMin
      }
    }
  }
`;

export const UPDATE_TICKET_PERCEIVED_RACE = gql`
  mutation addOrUpdateTicketInIncident(
    $input: AddOrUpdateTicketInIncidentInput!
  ) {
    addOrUpdateTicketInIncident(input: $input) {
      errors
      incidentUuid
      ticketUuid
      ticket {
        id
        perceivedRace {
          id
          name
          oriId
          position
        }
      }
    }
  }
`;

export const UPDATE_TICKET_POINTS = gql`
  mutation addOrUpdateTicketInIncident(
    $input: AddOrUpdateTicketInIncidentInput!
  ) {
    addOrUpdateTicketInIncident(input: $input) {
      errors
      incidentUuid
      ticketUuid
      ticket {
        id
        points
      }
    }
  }
`;

export const UPDATE_TICKET_POSTED_LIMIT = gql`
  mutation addOrUpdateTicketInIncident(
    $input: AddOrUpdateTicketInIncidentInput!
  ) {
    addOrUpdateTicketInIncident(input: $input) {
      errors
      incidentUuid
      ticketUuid
      ticket {
        id
        postedLimit
      }
    }
  }
`;

export const UPDATE_TICKET_RELATIVE_CRIME_CHARGE = gql`
  mutation addOrUpdateTicketInIncident(
    $input: AddOrUpdateTicketInIncidentInput!
  ) {
    addOrUpdateTicketInIncident(input: $input) {
      errors
      incidentUuid
      ticketUuid
      ticket {
        id
        relativeCrimeCharge
      }
    }
  }
`;

export const UPDATE_TICKET_RELIEF_ACT_COMMENT = gql`
  mutation addOrUpdateTicketInIncident(
    $input: AddOrUpdateTicketInIncidentInput!
  ) {
    addOrUpdateTicketInIncident(input: $input) {
      errors
      incidentUuid
      ticketUuid
      ticket {
        id
        reliefActComment
      }
    }
  }
`;

export const UPDATE_TICKET_RELIEF_ACT_TYPE = gql`
  mutation addOrUpdateTicketInIncident(
    $input: AddOrUpdateTicketInIncidentInput!
  ) {
    addOrUpdateTicketInIncident(input: $input) {
      errors
      incidentUuid
      ticketUuid
      ticket {
        id
        reliefActType {
          id
          name
          oriId
          position
        }
      }
    }
  }
`;

export const UPDATE_TICKET_RESTITUTION = gql`
  mutation addOrUpdateTicketInIncident(
    $input: AddOrUpdateTicketInIncidentInput!
  ) {
    addOrUpdateTicketInIncident(input: $input) {
      errors
      incidentUuid
      ticketUuid
      ticket {
        id
        restitution
      }
    }
  }
`;

export const UPDATE_TICKET_SEAT_BELT_OCCURRENCE = gql`
  mutation addOrUpdateTicketInIncident(
    $input: AddOrUpdateTicketInIncidentInput!
  ) {
    addOrUpdateTicketInIncident(input: $input) {
      errors
      incidentUuid
      ticketUuid
      ticket {
        id
        seatBeltOccurrence
      }
    }
  }
`;
export const UPDATE_TICKET_SEAT_VIOLATION_OCCURRENCE = gql`
  mutation addOrUpdateTicketInIncident(
    $input: AddOrUpdateTicketInIncidentInput!
  ) {
    addOrUpdateTicketInIncident(input: $input) {
      errors
      incidentUuid
      ticketUuid
      ticket {
        id
        violationOccurrence {
          id
          name
        }
      }
    }
  }
`;

export const UPDATE_TICKET_SEAT_BELT_VIOLATION = gql`
  mutation addOrUpdateTicketInIncident(
    $input: AddOrUpdateTicketInIncidentInput!
  ) {
    addOrUpdateTicketInIncident(input: $input) {
      errors
      incidentUuid
      ticketUuid
      ticket {
        id
        seatBeltVio
      }
    }
  }
`;

export const UPDATE_TICKET_SPEED_MEASUREMENT = gql`
  mutation addOrUpdateTicketInIncident(
    $input: AddOrUpdateTicketInIncidentInput!
  ) {
    addOrUpdateTicketInIncident(input: $input) {
      errors
      incidentUuid
      ticketUuid
      ticket {
        id
        speedMeasurement {
          id
          laserDisplayLightsAfter
          laserDisplayLightsBefore
          laserIdStr
          laserKnownDistanceAfter
          laserKnownDistanceBefore
          laserScopeAlignmentAfter
          laserScopeAlignmentBefore
          laserSelfAfter
          laserSelfBefore
          laserTimeAfter
          laserTimeBefore
          radarDisplayLightsAfter
          radarDisplayLightsBefore
          radarIdStr
          radarInternalCalibrationAfter
          radarInternalCalibrationBefore
          radarSpeedometerVerifAfter
          radarSpeedometerVerifBefore
          radarTimeAfter
          radarTimeBefore
          radarTuningForksAfter
          radarTuningForksBefore
        }
      }
    }
  }
`;

export const UPDATE_TICKET_DELIVERY_TYPE = gql`
  mutation addOrUpdateTicketInIncident(
    $input: AddOrUpdateTicketInIncidentInput!
  ) {
    addOrUpdateTicketInIncident(input: $input) {
      errors
      incidentUuid
      ticketUuid
      ticket {
        id
        ticketDeliveryType {
          id
          name
          oriId
          position
        }
      }
    }
  }
`;

//Removed from UPDATE_TICKET_EVIDENCE on the ticketEvidenceType
// ticketEntry {
//   id
//   name
//   oriId
//   position
// }
export const UPDATE_TICKET_EVIDENCE = gql`
  mutation addOrUpdateTicketInIncident(
    $input: AddOrUpdateTicketInIncidentInput!
  ) {
    addOrUpdateTicketInIncident(input: $input) {
      errors
      incidentUuid
      ticketUuid
      ticket {
        id
        ticketEvidenceType {
          id
          name
          oriId
          position
        }
      }
    }
  }
`;

export const UPDATE_TICKET_LOCATION = gql`
  mutation addOrUpdateTicketInIncident(
    $input: AddOrUpdateTicketInIncidentInput!
  ) {
    addOrUpdateTicketInIncident(input: $input) {
      errors
      incidentUuid
      ticketUuid
      ticket {
        id
        ticketLocation {
          city
          id
          lat
          lng
          name
          state
          streetName
          streetNumber
          unit
          uuid
          validAddressAlerts {
            alertType {
              id
              name
              alertLevel
              oriId
              position
            }
            expireAt
            id
            notes
            createdAt
            officer {
              deptAttribute {
                id
                badge
                ori {
                  id
                  abbreviation
                }
              }
              personalAttribute {
                id
                firstName
                lastName
              }
            }
          }
          zip
        }
      }
    }
  }
`;

export const UPDATE_TICKET_NUMBER = gql`
  mutation addOrUpdateTicketInIncident(
    $input: AddOrUpdateTicketInIncidentInput!
  ) {
    addOrUpdateTicketInIncident(input: $input) {
      errors
      incidentUuid
      ticketUuid
      ticket {
        id
        ticketNumber
      }
    }
  }
`;

export const UPDATE_TICKET_OUTCOME = gql`
  mutation addOrUpdateTicketInIncident(
    $input: AddOrUpdateTicketInIncidentInput!
  ) {
    addOrUpdateTicketInIncident(input: $input) {
      errors
      incidentUuid
      ticketUuid
      ticket {
        id
        ticketOutcomeType {
          id
          name
          oriId
          position
        }
      }
    }
  }
`;

export const UPDATE_TICKET_SEARCH = gql`
  mutation addOrUpdateTicketInIncident(
    $input: AddOrUpdateTicketInIncidentInput!
  ) {
    addOrUpdateTicketInIncident(input: $input) {
      errors
      incidentUuid
      ticketUuid
      ticket {
        id
        ticketSearchType {
          id
          name
          oriId
          position
        }
      }
    }
  }
`;

export const UPDATE_TICKET_STATUS = gql`
  mutation addOrUpdateTicketInIncident(
    $input: AddOrUpdateTicketInIncidentInput!
  ) {
    addOrUpdateTicketInIncident(input: $input) {
      errors
      incidentUuid
      ticketUuid
      ticket {
        id
        ticketStatus {
          id
          name
          oriId
          position
        }
      }
    }
  }
`;

export const UPDATE_TICKET_STOP = gql`
  mutation addOrUpdateTicketInIncident(
    $input: AddOrUpdateTicketInIncidentInput!
  ) {
    addOrUpdateTicketInIncident(input: $input) {
      errors
      incidentUuid
      ticketUuid
      ticket {
        id
        ticketStopType {
          id
          name
          oriId
          position
        }
      }
    }
  }
`;

export const UPDATE_TICKET_VIOLATION_TYPE = gql`
  mutation addOrUpdateTicketInIncident(
    $input: AddOrUpdateTicketInIncidentInput!
  ) {
    addOrUpdateTicketInIncident(input: $input) {
      errors
      incidentUuid
      ticketUuid
      ticket {
        id
        ticketViolationPrototype {
          code
          fullName
          id
          maxPenalty
          minPenalty
          name
          oriId
          points
          position
          civilViolation
          municipalOrdinance
          ticketCategory {
            id
            name
            oriId
            position
          }
          ticketEntry {
            id
            name
            oriId
            position
          }
          ticketSubCategory {
            id
            name
            oriId
            position
          }
          waiver
        }
      }
    }
  }
`;

export const UPDATE_TICKET_TRESPASS_REQUESTOR = gql`
  mutation addOrUpdateTicketInIncident(
    $input: AddOrUpdateTicketInIncidentInput!
  ) {
    addOrUpdateTicketInIncident(input: $input) {
      errors
      incidentUuid
      ticketUuid
      ticket {
        id
        trespassRequestor {
          id
          personalAttribute {
            id
            lastName
            firstName
            middleName
          }
        }
      }
    }
  }
`;

export const UPDATE_TICKET_TRESPASS_UNTIL = gql`
  mutation addOrUpdateTicketInIncident(
    $input: AddOrUpdateTicketInIncidentInput!
  ) {
    addOrUpdateTicketInIncident(input: $input) {
      errors
      incidentUuid
      ticketUuid
      ticket {
        id
        trespassUntil
      }
    }
  }
`;

export const UPDATE_TICKET_UOF_INJURY_DETAILS = gql`
  mutation addOrUpdateTicketInIncident(
    $input: AddOrUpdateTicketInIncidentInput!
  ) {
    addOrUpdateTicketInIncident(input: $input) {
      errors
      incidentUuid
      ticketUuid
      ticket {
        id
        uofInjuryDetails {
          id
          name
          oriId
          position
        }
      }
    }
  }
`;

export const UPDATE_TICKET_UOF_INSTANCE = gql`
  mutation addOrUpdateTicketInIncident(
    $input: AddOrUpdateTicketInIncidentInput!
  ) {
    addOrUpdateTicketInIncident(input: $input) {
      errors
      incidentUuid
      ticketUuid
      ticket {
        id
        uofInstance {
          id
          name
          oriId
          position
        }
      }
    }
  }
`;

export const UPDATE_TICKET_UOF_INSTANCE_TYPES = gql`
  mutation addOrUpdateTicketInIncident(
    $input: AddOrUpdateTicketInIncidentInput!
  ) {
    addOrUpdateTicketInIncident(input: $input) {
      errors
      incidentUuid
      ticketUuid
      ticket {
        id
        uofInstanceTypes {
          id
          name
          oriId
          position
        }
      }
    }
  }
`;

export const UPDATE_TICKET_VEHICLE = gql`
  mutation addOrUpdateTicketInIncident(
    $input: AddOrUpdateTicketInIncidentInput!
  ) {
    addOrUpdateTicketInIncident(input: $input) {
      errors
      incidentUuid
      ticketUuid
      ticket {
        id
        vehicle {
          id
          vehicleMake {
            id
            name
            oriId
            position
          }
          vehicleModel {
            id
            name
            oriId
            position
          }
          vehiclePlate {
            id
            name
            oriId
            position
          }
          validVehicleAlerts {
            alertType {
              id
              name
              alertLevel
              oriId
              position
            }
            expireAt
            id
            notes
            officerId
            vehicle {
              id
            }
          }
        }
      }
    }
  }
`;

export const UPDATE_TICKET_VIOLATION_DATE = gql`
  mutation addOrUpdateTicketInIncident(
    $input: AddOrUpdateTicketInIncidentInput!
  ) {
    addOrUpdateTicketInIncident(input: $input) {
      errors
      incidentUuid
      ticketUuid
      ticket {
        id
        violationDate
      }
    }
  }
`;
export const UPDATE_TICKET_WAIVER = gql`
  mutation addOrUpdateTicketInIncident(
    $input: AddOrUpdateTicketInIncidentInput!
  ) {
    addOrUpdateTicketInIncident(input: $input) {
      errors
      incidentUuid
      ticketUuid
      ticket {
        id
        waiver
      }
    }
  }
`;
export const UPDATE_TICKET_WEIGHT_LIMIT = gql`
  mutation addOrUpdateTicketInIncident(
    $input: AddOrUpdateTicketInIncidentInput!
  ) {
    addOrUpdateTicketInIncident(input: $input) {
      errors
      incidentUuid
      ticketUuid
      ticket {
        id
        weightLimit {
          id
          name
        }
      }
    }
  }
`;

export const UPDATE_TICKET_ALL_FIELDS = gql`
  mutation addOrUpdateTicketInIncident(
    $input: AddOrUpdateTicketInIncidentInput!
  ) {
    addOrUpdateTicketInIncident(input: $input) {
      errors
      incidentUuid
      ticketUuid
      ticket {
        accident
        actualSpeed
        cdl
        code
        commercialVehicle
        currentStatus
        cvHazardFee
        defendantActions
        defendantParent {
          id
          personalAttribute {
            id
            lastName
            firstName
            middleName
            mailingAddress {
              city
              id
              lat
              lng
              name
              state
              streetName
              streetNumber
              unit
              zip
            }
          }
        }
        deliveredToType {
          id
          name
          oriId
          position
        }
        dispositionPenaltyAmount
        fatality
        federalViolationCode {
          id
          name
          oriId
          position
        }
        hazmat
        highway {
          id
          name
          oriId
          position
        }
        id
        issuedAt
        issuedTo {
          id
          personalAttribute {
            id
            lastName
            firstName
            middleName
          }
        }
        issuedToAddress {
          city
          id
          lat
          lng
          name
          state
          streetName
          streetNumber
          unit
          uuid
          validAddressAlerts {
            alertType {
              id
              name
              alertLevel
              oriId
              position
            }
            expireAt
            id
            notes
            createdAt
            officer {
              deptAttribute {
                id
                badge
                ori {
                  id
                  abbreviation
                }
              }
              personalAttribute {
                id
                firstName
                lastName
              }
            }
          }
          zip
        }
        locked
        mailingAddressVerified
        municipalOrdinance
        municipality {
          id
          name
          oriId
          position
        }
        narrative
        officer {
          id
          personalAttribute {
            lastName
            firstName
            middleName
            id
          }
          deptAttribute {
            ori {
              id
              oriName
              abbreviation
            }
            badge
            id
          }
        }
        operator {
          id
          personalAttribute {
            id
            lastName
            firstName
            middleName
          }
        }
        passengerTicketEvidenceType {
          id
          name
          oriId
          position
        }
        passengerTicketOutcomeType {
          id
          name
          oriId
          position
        }
        passengerTicketSearchType {
          id
          name
          oriId
          position
        }
        penalty
        penaltyMax
        penaltyMin
        perceivedRace {
          id
          name
          oriId
          position
        }
        points
        postedLimit
        relativeCrimeCharge
        reliefActComment
        reliefActType {
          id
          name
          oriId
          position
        }
        restitution
        seatBeltOccurrence
        seatBeltVio
        ticketDeliveryType {
          id
          name
          oriId
          position
        }
        ticketEvidenceType {
          id
          name
          oriId
          position
        }
        ticketLocation {
          city
          id
          lat
          lng
          name
          state
          streetName
          streetNumber
          unit
          uuid
          validAddressAlerts {
            alertType {
              id
              name
              alertLevel
              oriId
              position
            }
            expireAt
            id
            notes
            createdAt
            officer {
              deptAttribute {
                id
                badge
                ori {
                  id
                  abbreviation
                }
              }
              personalAttribute {
                id
                firstName
                lastName
              }
            }
          }
          zip
        }
        ticketNumber
        ticketOutcomeType {
          id
          name
          oriId
          position
        }
        ticketSearchType {
          id
          name
          oriId
          position
        }
        ticketStatus {
          id
          name
          oriId
          position
        }
        ticketStopType {
          id
          name
          oriId
          position
        }
        ticketViolationPrototype {
          code
          fullName
          id
          maxPenalty
          minPenalty
          civilViolation
          municipalOrdinance
          name
          oriId
          points
          position
          civilViolation
          municipalOrdinance
          ticketCategory {
            id
            name
            oriId
            position
          }
          ticketEntry {
            id
            name
            oriId
            position
          }
          ticketSubCategory {
            id
            name
            oriId
            position
          }
          waiver
        }
        trespassRequestor {
          id
          personalAttribute {
            id
            lastName
            firstName
            middleName
          }
        }
        trespassUntil
        uofInjuryDetails {
          id
          name
          oriId
          position
        }
        uofInstance {
          id
          name
          oriId
          position
        }
        uofInstanceTypes {
          id
          name
          oriId
          position
        }
        vehicle {
          id
          vehicleMake {
            id
            name
            oriId
            position
          }
          vehicleModel {
            id
            name
            oriId
            position
          }
          vehiclePlate {
            id
            name
            oriId
            position
          }
          validVehicleAlerts {
            alertType {
              id
              name
              alertLevel
              oriId
              position
            }
            expireAt
            id
            notes
            officerId
            vehicle {
              id
            }
          }
        }
        violationDate
        waiver
      }
    }
  }
`;
